import router from '@/router';
import Axios from 'Core/axios';
import Rest from 'Core/rest';

// actions
const actions = {
  checkOnlineStatus({ dispatch }) {
    dispatch('mask', true);
    Axios.post(Rest.common.checkOnlineStatus())
      .then((response) => {
        dispatch('mask', false);
        dispatch('updateOnlineStatusInfo', response);
      })
      .catch((error) => {
        console.log(error);
        dispatch('mask', false);
        dispatch('showErrorMsg', error);
      });
  },
  getReferenceData({ dispatch }) {
    dispatch('mask', true);
    Axios.post(Rest.common.getReferenceData())
      .then((response) => {
        dispatch('mask', false);
        dispatch('updateReferenceData', response);
      })
      .catch((error) => {
        console.log(error);
        dispatch('mask', false);
        dispatch('showErrorMsg', error);
      });
  },
  bookingRepose({ dispatch }, requestData) {
    dispatch('mask', true);
    let requestBody = {
      param: JSON.stringify(requestData),
    };
    Axios.post(Rest.payment.bookingRepose(), requestBody)
      .then((response) => {
        dispatch('mask', false);
        // if (window.innerWidth < 768) {
        //   window.location.href = response.appUrl;
        // } else {
        window.location.href = response.webUrl;
        // }
      })
      .catch((error) => {
        dispatch('mask', false);
        dispatch('showErrorMsg', error);
      });
  },
  bookingLight({ dispatch }, requestData) {
    dispatch('mask', true);
    let requestBody = {
      param: JSON.stringify(requestData),
    };
    Axios.post(Rest.payment.bookingLight(), requestBody)
      .then((response) => {
        dispatch('mask', false);
        // if (window.innerWidth < 768) {
        //   window.location.href = response.appUrl;
        // } else {
        window.location.href = response.webUrl;
        // }
      })
      .catch((error) => {
        dispatch('mask', false);
        dispatch('showErrorMsg', error);
      });
  },
  getOrderStatus({ dispatch }, requestData) {
    dispatch('mask', true);
    Axios.post(Rest.order.getOrderStatus(), requestData)
      .then((response) => {
        dispatch('mask', false);
        dispatch('updateOrderStatus', response);
      })
      .catch((error) => {
        dispatch('mask', false);
        dispatch('showErrorMsg', error);
      });
  },
  getBookingList({ dispatch }, requestData) {
    dispatch('mask', true);
    Axios.post(Rest.order.getBookingList(), requestData)
      .then((response) => {
        dispatch('mask', false);
        if (
          response.bookingList !== undefined &&
          response.bookingList.length > 0
        ) {
          dispatch('updateBookingList', response.bookingList);
        }
      })
      .catch((error) => {
        dispatch('mask', false);
        dispatch('showErrorMsg', error);
      });
  },
  getBookingInfo({ dispatch }, requestData) {
    dispatch('mask', true);
    Axios.post(Rest.order.getBookingInfo(), requestData)
      .then((response) => {
        dispatch('mask', false);
        dispatch('updateBookingInfo', response);
      })
      .catch((error) => {
        dispatch('mask', false);
        dispatch('showErrorMsg', error);
      });
  },
  showErrorMsg({ commit }, param) {
    commit('showErrorMsg', param);
  },
  clearErrorMsg({ commit }) {
    commit('clearErrorMsg');
  },
  showSuccessMsg({ commit }, param) {
    commit('showSuccessMsg', param);
  },
  clearSuccessMsg({ commit }) {
    commit('clearSuccessMsg');
  },
  mask({ commit }, status) {
    commit('mask', status);
  },
  showPopup({ commit }, param) {
    commit('popup', param);
  },
  hidePopup({ commit }) {
    commit('popup', { title: '', content: '' });
  },
  redirectLogin() {
    sessionStorage.clear();
    router.push({ path: '/Login' });
  },
  redirectWelcome() {
    router.push({ path: '/Welcome' });
  },
  modifyLightApplyInfo({ commit }, param) {
    commit('modifyLightApplyInfo', param);
  },
  clearLightApplyInfo({ commit }) {
    commit('clearLightApplyInfo');
  },
  modifyBanquetApplyInfo({ commit }, param) {
    commit('modifyBanquetApplyInfo', param);
  },
  clearBanquetApplyInfo({ commit }) {
    commit('clearBanquetApplyInfo');
  },
  updateOnlineStatusInfo({ commit }, param) {
    commit('updateOnlineStatusInfo', param);
  },
  updateReferenceData({ commit }, param) {
    commit('updateReferenceData', param);
  },
  updateOrderStatus({ commit }, param) {
    commit('updateOrderStatus', param);
  },
  clearOrderStatus({ commit }) {
    commit('clearOrderStatus');
  },
  updateBookingList({ commit }, param) {
    commit('updateBookingList', param);
  },
  clearBookingList({ commit }) {
    commit('clearBookingList');
  },
  updateBookingInfo({ commit }, param) {
    commit('updateBookingInfo', param);
  },
  clearBookingInfo({ commit }) {
    commit('clearBookingInfo');
  },
};

export default actions;
